import React from "react";
import { Link } from "react-router-dom";
import './header.css'

const Header = () => {
  return (
    <ul className="nav-bar">
      <li>
        <Link to="/admin/posts">Post List</Link>
      </li>
      <li>
        <Link to="/admin/posts/create">Create Post</Link>
      </li>
      <li>
        <Link to="/logout">Logout</Link>
      </li>
    </ul>
  );
};

export default Header;
